{
  "es": {
    "texts": {
      "index": "Your database for all information around Ships and Stations in Star Citizen.",
      "indexQuote": "“Strap into one of dozens of ships and embark on a life within the Star Citizen universe.<br>Unbound by profession or skill sets, you choose the path of your own life.”",
      "indexQuoteSource": "Author Unknown, Source:",
      "support": {
        "info": "¿Sin presupuesto? <a href=\"https://robertsspaceindustries.com/spectrum/community/SC/forum/57219/thread/fleetyards-net\" target=\"_blank\" rel=\"noopener\"><b>Vótanos en Spectrum</b></a> para que más gente encuentre FleetYards.",
        "goal": "Cubre los costes de funcionamiento, como el alojamiento y los servicios de datos.",
        "code": "¿Nuevo en Star Citizen? Usa este código para 5000 UEC iniciales:",
        "thisMonth": "de %{goal} este mes",
        "subline": "Apóyanos directamente",
        "otherWays": "Otras formas de ayudar"
      },
      "installApp": {
        "eventSignup": "Instala FleetYards como app para volver a tus eventos con un toque.",
        "iosIntro": "En iPhone y iPad, las apps como FleetYards se instalan desde el menú Compartir:",
        "iosShare": "Toca el botón Compartir en la barra del navegador.",
        "iosAdd": "Elige «Añadir a pantalla de inicio». Puede que tengas que desplazarte hacia abajo.",
        "iosConfirm": "Toca «Añadir». FleetYards se abre ahora desde tu pantalla de inicio como cualquier otra app."
      },
      "supportHint": {
        "hangarSync": "Las sincronizaciones en segundo plano son el mayor gasto de hosting. FleetYards funciona gracias a las donaciones — cualquier aporte ayuda.",
        "vehicleAdded": "FleetYards es gratuito, sin anuncios, y funciona solo con donaciones. Si te resulta útil, una pequeña aportación ayuda a mantenerlo así.",
        "fleetCreated": "Las flotas son una de nuestras funciones más exigentes. FleetYards sigue siendo gratuito y sin anuncios gracias a las donaciones — considera aportar.",
        "loginMilestone": "Llevas un tiempo con nosotros — gracias. FleetYards funciona con donaciones; si quieres ayudar a cubrir los costes, aquí está cómo.",
        "visitMilestone": "FleetYards se financia con la comunidad — sin anuncios, sin muros de pago. Si te resulta útil, una pequeña donación supone mucho."
      },
      "notFound": "You are currently venturing unknown space. In the event you are lost, the UEE highly recommends plotting a new destination back towards home-space.",
      "forbidden": "Tu autorización no cubre esta zona. Si una función se está desplegando todavía, podrás activarla tú mismo en Ajustes > Funciones en cuanto esté disponible.",
      "subscriptionRequired": "Contratos, eventos, logistics y expediciones se mantienen gracias a quienes apoyan FleetYards. Esta flota no está cubierta ahora mismo: la contribución de un solo miembro abre las cuatro para toda la flota.",
      "featureNotReady": "Esta función aún no está lista y estará disponible pronto. ¡Esté atento!",
      "inviteInvalid": "Este enlace de invitación no es válido. Puede que se haya copiado mal, que haya caducado o que ya haya alcanzado su límite de usos. Pide un enlace nuevo a quien te invitó.",
      "accessDenied": "No está autorizado para ver esta página.",
      "serverError": "El servidor está experimentando dificultades técnicas. Inténtelo más tarde.",
      "offline": "La solicitud no ha llegado al servidor. Tu dispositivo parece estar sin conexión o no se ha podido contactar con el servidor. Comprueba tu conexión e inténtalo de nuevo.",
      "invalidRequest": "El servidor no ha podido procesar esta solicitud. Recarga la página e inténtalo de nuevo.",
      "invalidListRequest": "Este filtro u orden no es válido. Restablécelo para volver a ver la lista.",
      "compare": {
        "ships": {
          "info": "To start select at least two and not more than eight Ships you want to compare."
        }
      },
      "fleets": {
        "leaveInfo": "You can not leave a Fleet as an Admin.",
        "directory": "Flotas verificadas que han elegido ser encontradas. Cada flota aquí ha demostrado que dirige su organización de RSI."
      },
      "admin": {
        "destroyedFleets": {
          "purgedWarning": "La restauración de una flota purgada se hace en la medida de lo posible. Los roles, las imágenes, los enlaces de invitación y los vehículos de la flota no se restauran."
        },
        "models": {
          "viewsFolder": {
            "hint": "Suelta una carpeta de vistas con los nombres top.png, side.png, front.png y angled.png. Añade el sufijo _colored para el juego pintado, el prefijo extended_ para el extendido y landed_ para el aterrizado. El prefijo flight_, o ninguno, va al juego predeterminado. holo.gltf también se incluye, con los mismos prefijos.",
            "uploading": {
              "one": "Subiendo un archivo…",
              "other": "Subiendo %{count} archivos…"
            },
            "matched": {
              "one": "Un archivo listo — guarda para aplicarlo.",
              "other": "%{count} archivos listos — guarda para aplicarlos."
            },
            "ignored": "Ignorados: %{files}"
          }
        },
        "oauthApplications": {
          "rejectHint": "El motivo se muestra a quien registró la aplicación, así que indica qué debe cambiar."
        }
      },
      "hangarTour": {
        "welcome": {
          "title": "Bienvenido a tu hangar",
          "text": "Tu hangar lleva la cuenta de todas las naves que tienes. Este breve recorrido te muestra dónde está todo — puedes repetirlo desde el menú cuando quieras."
        },
        "add": {
          "title": "Añadir naves",
          "text": "Elige una o varias naves y cuántas de cada una. En la página o la tarjeta de cada nave, el icono de marcador también la añade a tu hangar o a tu lista de deseos."
        },
        "sync": {
          "title": "Sincronizar con RSI",
          "text": "¿Ya tienes pledges? Con la extensión de navegador de FleetYards sincroniza tu hangar de RSI en lugar de añadir naves a mano — y otra vez cuando cambien tus pledges."
        },
        "display": {
          "title": "Opciones de visualización",
          "text": "Cambia entre tarjetas y lista, define tu orden predeterminado y elige qué detalles o columnas se muestran. En la lista puedes seleccionar varias naves y cambiarlas a la vez."
        },
        "groups": {
          "title": "Grupos",
          "text": "Ordena tus naves en grupos propios con + y el lápiz. Haz clic en un grupo para filtrar por él o pasa el cursor para resaltar sus naves."
        },
        "vehicle": {
          "title": "El menú de cada nave",
          "text": "Edita una nave desde aquí: ponle nombre, elige su pintura, hazla tu nave insignia, ajusta su visibilidad, gestiona sus loadouts o muévela a tu lista de deseos."
        },
        "wishlist": {
          "title": "Lista de deseos",
          "text": "Las naves que quieres pero aún no tienes van a tu lista de deseos, con avisos de rebajas opcionales."
        },
        "fleetchart": {
          "title": "Fleetchart",
          "text": "Coloca tus naves una junto a otra a escala y guarda el gráfico como imagen."
        },
        "stats": {
          "title": "Estadísticas",
          "text": "Roles, fabricantes, tamaños y lo que has gastado, con exportación CSV."
        },
        "share": {
          "title": "Comparte tu hangar",
          "text": "Tu hangar público está activado. Comparte su enlace — tú decides qué naves y grupos aparecen."
        },
        "menu": {
          "title": "Más",
          "text": "Importa y exporta tu hangar, buy-backs y tu historial de importaciones — y este recorrido, siempre que lo necesites."
        }
      },
      "fleetTour": {
        "welcome": {
          "title": "Tu flota está lista",
          "text": "Este recorrido abre cada página donde se configura y señala lo importante en ella. El signo de interrogación en la parte superior de la página de la flota lo vuelve a abrir cuando quieras."
        },
        "events": {
          "title": "Eventos y misiones",
          "text": "Planifica operaciones, deja que los miembros se apunten a una nave y un puesto, y tenlo todo en el calendario de la flota."
        },
        "contracts": {
          "title": "Contratos",
          "text": "Publica trabajos para tus miembros y págales cuando estén terminados."
        },
        "members": {
          "title": "Invitar miembros",
          "text": "Invita a personas por su nombre de usuario de Fleetyards o crea un enlace de invitación para compartirlo en Discord o RSI. Las solicitudes para unirse también llegan a esta página."
        },
        "ships": {
          "title": "Naves y fleetchart",
          "text": "Las naves que comparten tus miembros forman juntas las naves de la flota. El fleetchart las coloca una junto a otra a escala."
        },
        "membership": {
          "title": "Tus naves en la flota",
          "text": "Cada miembro decide qué naves suyas ve la flota: todas, un grupo del hangar o ninguna. Aquí eliges las tuyas."
        },
        "rsi": {
          "title": "Verifica tu organización de RSI",
          "text": "Introduce el SID de tu organización y verifícalo. La verificación demuestra que la organización es tuya y protege el ID de tu flota."
        },
        "roles": {
          "title": "Roles",
          "text": "Cada rol decide qué pueden ver y gestionar sus miembros. Esta página muestra lo que puede hacer cada rol."
        },
        "squadrons": {
          "title": "Escuadrones y equipos",
          "text": "Activa los escuadrones para dividir a los miembros en unidades y equipos, cada uno con sus propios rangos."
        },
        "discord": {
          "title": "Conectar Discord",
          "text": "Instala el bot en tu servidor de Discord para dar a cada rango un rol de Discord y reflejar los eventos como eventos programados."
        },
        "settings": {
          "title": "Página pública de la flota",
          "text": "Decide si la página de la flota y sus naves son públicas; el logo, la descripción y los enlaces también están aquí."
        },
        "finish": {
          "title": "Tu flota está configurada",
          "text": "Eso es todo para empezar. El signo de interrogación de aquí arriba vuelve a abrir este recorrido cuando quieras."
        }
      },
      "hangarPreview": {
        "sync": {
          "title": "Sincronizar con RSI",
          "text": "Importa tus pledges con la extensión de navegador o un archivo de hangarXPLOR en lugar de añadir naves una a una."
        },
        "organise": {
          "title": "Organiza tus naves",
          "text": "Pon nombre a tus naves, define pinturas, loadouts y nave insignia, y ordénalas en grupos propios."
        },
        "wishlist": {
          "title": "Lista de deseos y rebajas",
          "text": "Guarda las naves que quieres en una lista de deseos y recibe un aviso cuando estén en rebajas."
        },
        "fleetchart": {
          "title": "Fleetchart",
          "text": "Mira tus naves una junto a otra a escala y guarda el gráfico como imagen."
        },
        "stats": {
          "title": "Estadísticas del hangar",
          "text": "Roles, fabricantes, tamaños y lo que has gastado, de un vistazo."
        },
        "share": {
          "title": "Hangar público",
          "text": "Comparte tu hangar con un enlace — tú decides qué naves y grupos son visibles."
        }
      },
      "fleetPreview": {
        "members": {
          "title": "Miembros y roles",
          "text": "Invita a los miembros de tu org con un enlace y organízalos con roles y escuadrones."
        },
        "ships": {
          "title": "Naves de la flota",
          "text": "Las naves públicas de todos los miembros en una lista que puedes filtrar y buscar."
        },
        "fleetchart": {
          "title": "Fleetchart",
          "text": "Mira toda la flota una nave junto a otra a escala y guárdala como imagen."
        },
        "stats": {
          "title": "Estadísticas de la flota",
          "text": "Analiza tu flota por rol, tamaño y capacidad de carga."
        },
        "allies": {
          "title": "Aliados",
          "text": "Alíate con otras flotas y lleva la cuenta de con quién vuelas."
        },
        "discord": {
          "title": "Discord",
          "text": "Publica anuncios y un resumen semanal en tu servidor de Discord, y deja que los miembros se unan mediante un rol."
        }
      },
      "impressum": {
        "visit": "Visita",
        "ytShipImages": "The Awesome Ship Images in the Hangar Fleetchart view are the work of <a href=\"https://twitter.com/WhyTeeZero\" target=\"_blank\" rel=\"noopener\">YT (Twitter: @WhyTeeZero)</a>.<br>Please visit his Spectrum post (see links below) and give him a upvote.",
        "erkul": "The ship metrics on Fleetyards are modelled on the formulas and readouts of Erkul's DPS Calculator. Thanks to the erkul.games team for sharing their work with the community.",
        "appSignal": "AppSignal provided a sponsored Open Source Account which helps to improve Fleetyards.net even further. Thanks :)",
        "copyright": "The contents and works created by the page operators, on these pages are subject to German copyright. Duplication, processing, distribution and any kind of exploitation outside the limits of Copyright require the written consent of the respective author or creator. Downloads and copies of this page are only for private, non-commercial use. Insofar as the content on This page was not created by the operator, are third-party copyrights respected. In particular, Third-party content as such. Please Contact us if you notice any sort of copyright infringement. We will remove any content immediately as we become aware of such violations.",
        "disclaimer": {
          "p1": "This is an unofficial Star Citizen fansite, not affiliated with the Cloud Imperium group of companies.",
          "p2": "All content on this site not authored by its host or users are property of their respective owners.",
          "p3": "Star Citizen®, Squadron 42®, Roberts Space Industries®, and Cloud Imperium® are registered trademarks of Cloud Imperium Rights LLC. All rights reserved."
        },
        "liabilityInternal": {
          "p1": "The content of out site has been compiled with meticulous care and to the best of our knowledge. However, We cannot assume any liability for the up-to-dateness, completeness or accuracy of any of the pages.",
          "p2": "Pursuant to section 7, para. 1 of the TMG (Telemediengesetz), We are liable for our own content on these pages in accordance with general laws. However, pursuant to sections 8 to 10 of the TMG, We are not under obligation to monitor external information provided or stored on our site. Once We have become aware of a specific infringement of the law, We will immediately remove the content in question. Any liability concerning this matter can only be assumed from the point in time at which the infringement becomes known to us."
        },
        "liabilityExternal": "Our site contains links to websites of third parties (“external links”). As the content of these sites is not under our control, We cannot assume any liability for such external content. In all cases, the provider of information of the linked sites is liable for the content and accuracy of the information provided. At the point in time when the links were placed, no infringements of the law were recognisable to us. As soon as an infringement of the law becomes known to us, We will immediately remove the link in question."
      },
      "privacy": {
        "text": "The use of our site is usually possible without providing any personal data. The collecting of personal data (eg email address) on our sites will be, as far as possible, on a voluntary basis. No personal data will be passed on to third parties without your explicit consent.<br>We point out that data transmission over the Internet (eg when communicating by email) can have security gaps. A complete protection of data against access by third parties is not possible.",
        "p1": "Below you can read about what Information we are using to provide you the services on %{app}. For most parts this only concerns registered Users but please read further to get a full overview.",
        "p2": {
          "headline": "¿Qué información usamos?",
          "text": "Depending on if you are a registered User or only using %{app} as a Guest we use more or less Information from you."
        },
        "p3": {
          "headline": "Como invitado",
          "text": "Como invitado en %{app} recopilamos los siguientes datos:"
        },
        "analytics": {
          "headline": "Analíticas de uso",
          "basis": "%{app} cuenta las visitas a las páginas para saber qué partes del sitio se usan realmente. Esto se basa en nuestro interés legítimo en operar y mejorar el sitio, no en el consentimiento: los datos se recogen únicamente de forma propia, las direcciones IP se anonimizan antes de almacenarse, no se colocan cookies ni otros identificadores en tu dispositivo y no se comparte nada con redes publicitarias.",
          "retention": "Las visitas individuales y las páginas vistas se eliminan al cabo de un mes. Más allá de ese plazo solo se conservan recuentos agregados, que no pueden vincularse a una persona. Eliminar tu cuenta también elimina las visitas registradas para ella.",
          "objection": {
            "headline": "Cómo oponerse",
            "text": "Puedes oponerte a las analíticas de uso en cualquier momento, y dejaremos de registrarlas en lugar de limitarnos a ocultarlas.",
            "user": "El ajuste de tu cuenta en Configuración se aplica a todos los dispositivos en los que inicies sesión.",
            "guest": "Sin una cuenta puedes oponerte aquí. También respetamos la señal Global Privacy Control si tu navegador la envía."
          }
        }
      },
      "settings": {
        "privacy": {
          "tracking": "Cuando esto está activado contamos las páginas que visitas para ver qué partes del sitio se usan. Las direcciones IP se anonimizan, no se almacena nada en tu dispositivo y las visitas individuales se eliminan al cabo de un mes. Desactivarlo detiene el registro por completo.",
          "onlineStatus": "Cuando está activado, los miembros de tus flotas y tus amigos ven un punto junto a tu nombre mientras tienes FleetYards abierto. Al desactivarlo se les oculta: nada más cambia y tu última actividad se sigue mostrando."
        },
        "notifications": {
          "hint": "Elige cómo te llega cada evento. Las notificaciones de la app se recogen en tu centro de notificaciones; el correo se envía a la dirección de tu cuenta.",
          "push": {
            "title": "Notificaciones push",
            "intro": "Recibe notificaciones en este dispositivo incluso con FleetYards cerrado. Cuáles llegan como push se elige en la columna Push de abajo.",
            "unsupported": "Este navegador no puede recibir notificaciones push. En un iPhone o iPad, añade FleetYards a la pantalla de inicio y ábrelo desde allí.",
            "denied": "Las notificaciones de FleetYards están bloqueadas en este navegador. Permítelas en la configuración del sitio del navegador y vuelve a cargar esta página.",
            "on": "Las notificaciones push están activadas en este dispositivo.",
            "off": "Las notificaciones push están desactivadas en este dispositivo.",
            "device": "%{browser} en %{os}",
            "unknownDevice": "Navegador desconocido",
            "thisDevice": "(este dispositivo)",
            "failed": "No se pudo comprobar el estado de las notificaciones push en este dispositivo. Vuelve a cargar la página para intentarlo de nuevo."
          }
        }
      },
      "signup": {
        "blocked": "You have been blocked from FleetYards.net.<br>This can have multiple Reasons.<br>For further Information please Contact us under info ( at ) fleetyards.net"
      },
      "roadmap": {
        "inactive": "This Item was removed from the Roadmap. This is its last location"
      },
      "twoFactor": {
        "backupCodes": "Save a copy of your Backup-Codes. They will only be visible this one time.",
        "disable": "Para deshabilitar la autenticación de dos factores, simplemente ingrese un token válido.",
        "enable": " To secure your FleetYards.net Account you can generate 2-Factor-Auth Tokens with Google Authenticator, 1Password or Authy."
      },
      "oauthAuthorize": {
        "requestingAccess": "%{clientName} está solicitando acceso a su cuenta.",
        "scopesIntro": "Esta aplicación podrá:"
      },
      "hangarFlair": {
        "intro": "La decoración de hangar de tu hangar de RSI, según tu última sincronización del hangar. La sincronización lee tu hangar de RSI mediante la extensión Fleetyards Sync."
      },
      "hangarPaints": {
        "intro": "Las pinturas de tu hangar de RSI, según tu última sincronización del hangar. La sincronización lee tu hangar de RSI mediante la extensión Fleetyards Sync."
      },
      "buybacks": {
        "intro": "Los pledges que fundiste en RSI y podrías recomprar, según tu última sincronización. La sincronización lee tu lista de recompra de RSI mediante la extensión Fleetyards Sync."
      },
      "buybackSync": {
        "info": "Lee cada página de tu lista de recompra de RSI y reemplaza con ella los pledges de recompra guardados en Fleetyards. Tu hangar no se modifica. Las listas largas tardan unos minutos.",
        "unsupported": "Tu extensión Fleetyards Sync todavía no puede leer los pledges de recompra. Actualízala para sincronizarlos.",
        "detailsInfo": "La primera sincronización también lee el precio y el seguro de cada pledge, una página de RSI por cada uno, lo que puede tardar un cuarto de hora con una lista larga. Las siguientes solo leen los nuevos.",
        "detailsUnsupported": "Actualiza tu extensión Fleetyards Sync para leer también precios y seguros.",
        "detailsIncomplete": "No se pudieron leer algunos precios de RSI. La próxima sincronización lo volverá a intentar."
      },
      "syncExtension": {
        "gettingStarted": "To sync your RSI Hangar with Fleetyards you first need to install the Fleetyards Sync Extension for Firefox or Chromium based Browsers.",
        "info": "We will try to match the ships from your RSI Hangar with your existing ships in your Fleetyards Hangar by using the name and the pledge-id. Ships from the RSI Hangar without a match will be added to your Fleetyards Hangar.<br><br>Do you want to continue?",
        "alreadyRunning": "Ya hay una sincronización de hangar en progreso. Espere a que termine.",
        "missingUnmatchedGroup": "Elige antes de empezar el grupo en el que archivar las naves que la sincronización no encuentre."
      },
      "setEmail": "Para establecer una contraseña, activar la autenticación de dos factores o recibir notificaciones por correo, necesitas añadir una dirección de correo a tu cuenta. Recibirás un correo de confirmación para verificar la dirección.",
      "oauthApplications": {
        "pendingReview": "Esta aplicación está registrada y espera revisión. No puede solicitar acceso hasta que sea aprobada.",
        "rejected": "Esta aplicación fue rechazada y no puede solicitar acceso. Corregir lo que indica el motivo la devuelve a la cola.",
        "returnedToReview": "Cambiar la URI de redirección o los permisos devuelve a revisión una aplicación aprobada."
      },
      "payouts": {
        "accountFound": "%{username} tiene una cuenta de FleetYards y se vinculará a este participante.",
        "accountMissing": "Ninguna cuenta de FleetYards tiene este usuario. Revisa cómo está escrito o añádela abajo por nombre como invitado.",
        "guestHint": "Para alguien sin cuenta de FleetYards. Aparecerá como invitado.",
        "deleteHint": "Aún no hay nadie más en esta expedición, así que se puede eliminar.",
        "tourInvite": "%{username} te invita a unirte a esta expedición.",
        "contractReady": "El contrato está cumplido. Abre su libro de pagos para pagar la recompensa a los contratistas.",
        "contractNotReady": "Todavía no se ha abierto un libro de pagos para este contrato.",
        "expenseNeedsReview": "Un gasto cuenta cuando quien gestiona el libro lo aprueba."
      },
      "fleet": {
        "contractCovers": "La imagen que el tablero muestra para cada tipo de contrato. Si dejas una vacía, se usa la imagen incorporada de abajo."
      }
    }
  }
}
